import { useTenantsStore } from '@/stores/tenants';

const hasCurrentTenant = () => !!useTenantsStore().currentTenant;
export default hasCurrentTenant;
